// extracted by mini-css-extract-plugin
module.exports = {"container":"_bd4f877","value":"_619828b"};